module.exports = __webpack_public_path__ + "static/media/avatars_female_11.87390fd3.png";